import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  CpEmptyStateWrapper,
  CpEmptyStateText,
} from './project-forms/empty-state';

export const CpProjectPlanEmptyState: React.FC = () => {
  return (
    <CpEmptyStateWrapper>
      <CpEmptyStateText data-cy="cp.project-plan.empty-state">
        <FormattedMessage id="cp.project_plan.empty_state.message" />
      </CpEmptyStateText>
    </CpEmptyStateWrapper>
  );
};
